import React from "react";
import CreateModelHeader from "./components/CreateModelHeader";
import CreateModelProgress from "./components/CreateModelProgress";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import FormikControl from "../../components/signUpForm/ReusableFormik/FormikControl";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import "./Style.css"
import { useContext } from 'react';
import { ModelContext, ModelDataProvider } from './DataContext';

function CreateModelStep1(){

    const navigate = useNavigate();
    const location = useLocation();
    const data = location.state;
    const {saveModelData} = useContext(ModelContext);
    const {modelData} = useContext(ModelContext);
    

    const options = [
        { value: '', key: 'Select' },
        { value: 'Apply model to all new applicants', key: 'Apply model to all new applicants' },
        { value: 'Apply model to selected applicants', key: 'Apply model to selected applicants' },
    ];

    const validationSchema = Yup.object({
        modelCondition: Yup.string().required("Select an option"),
        modelName: Yup.string().required("Model name Required"),
      
    });

    const initialValues = {
        modelCondition: '',
        modelName:'',
    } 

    //   Form submission
    const onSubmit = (values) => {   
        navigate("/CreateModelStep2");
        saveModelData(values);
        console.log("Previous data ", data);
    };

    
    // const formik = useFormik({
    //     initialValues: {
    //         modelName: ""

    //     }, validate: (values) => {
    //         const errors = {};       
    //             if(!values.modelName){
    //                 errors.modelName = "Model name required";
    //             }                         
    //         return errors;
    //     }, 
    //     onSubmit: (values) =>{
    //         if(selectedOption !== " "){
    //             navigate("/CreateModelStep2")
    //         }
          
    //     }
    // })

    return(
   // <ModelDataProvider>
        <div>
            <div className="">
                <CreateModelHeader/>
            </div>
            <div>
                <CreateModelProgress title={'Create Predition Model'} indexActualPage={1}/>
            </div>

            <div className="flex flex-col items-center mt-5">
                <div className="xl:w-[560px] sm:w-[400px]"> 
                    {/* className="mt-5 flex flex-col items-center justify-center bg-red-100" */}
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={onSubmit}
                    >
                        {(formik) => {
                            return (
                                <Form className="">
                                    <FormikControl
                                        control="input"
                                        label="Model Name"
                                        type="text"                                       
                                        name="modelName"
                                        //onChange  = {handleInputChange}
                                    />   
                                    <span className="text-sm text-gray-600">The name you want to call this model</span>                               

                                    <FormikControl
                                        control="select"
                                        label="Condition for model application"
                                        // type="text"
                                        name="modelCondition"
                                        options={options}
                                    />

                                    <span className="flex justify-center mt-12">
                                        <button     
                                            type="submit" 
                                            className='bg-indigo-500 hover:bg-indigo-600 text-slate-50 border rounded-md xl:px-5 md:px-2 lg:px-3 xl:py-2 md:w-28 xl:w-[150px] xl:h-[56px] sm:w-28 sm:h-12 sm;text-xs' 
                                            disabled={!formik.isValid}>
                                            Continue
                                        </button>
                                    </span>
                                   
                                </Form>
                            );
                        }}
                    </Formik>  
                </div> 
            </div>
        </div>
  //  </ModelDataProvider>
    )

}

export default CreateModelStep1;





                {/* <div>moel name: {modelName}</div> */}
                

                    {/* <form onClick={formik.handleSubmit} className="">
                  
                        <div className="xl:w-[560px] sm:w-[400px] flex flex-col">
                            <label className="block text-xs sm:text-sm md:text-base font-normal mb-2 mt-8" htmlFor="modelName">Model Name</label>  
                            <input
                                id="modelName"
                                name= "modelName"
                                type="text"
                                value= {formik.values.modelName}
                                placeholder=' '                              
                                className="rounded-md w-full px-3 py-2 pr-10 text-xs md:text-sm border border-border-input focus:outline-none focus:ring-2 bg-white shadow-md lg:px-3"     
                                onBlur={formik.handleBlur}
                                onChange={handleInputChange}
                                // onChange={formik.handleChange}
                            />
                            <span className="text-sm text-gray-600 mt-1">The name you want to call this model</span>
                            {formik.errors.modelName &&  (
                                <span className="text-red-500 text-xs">{formik.errors.modelName}</span>
                            )}
                            
                        </div>
                                  
                        <div className="xl:w-[560px] sm:w-[400px] mb-20">

                            <Select
                                label = "Condition for model application"
                                name = "condition"
                                options = {options}
                            
                            />
                            {/* <label className="block text-xs sm:text-sm md:text-base font-normal mb-2 mt-8" htmlFor="dropdown1">Condition for model application</label>
                                <CustomSelect 
                                    id={"dropdown1"}
                                    options={options}
                                    onSelect={handleSelectOption}
                                />   
                           {selectedOption === "" ? <span>Please select an option</span> : ""} 
                            <div>slecnvjdb {selectedOption}</div>
                        </div>
                                
                        <span className="flex justify-center">
                            <button     
                                type="submit" 
                                className='bg-indigo-500 hover:bg-indigo-600 text-slate-50 border rounded-md xl:px-5 md:px-2 lg:px-3 xl:py-2 md:w-28 xl:w-[150px] xl:h-[56px] sm:w-28 sm:h-12 sm;text-xs' 
                            >
                                Continue
                            </button>
                        </span>
                
              
               
                    </form>  */}
               



